import { useState, useEffect } from 'react';
import axios from 'axios';
const T = { bg:'#f0f5e8', cream:'#fffef0', greenDk:'#1b5e20', maroon:'#6d1b1b', orange:'#e65100', border:'#c8e6c9', header:'linear-gradient(135deg,#090b72,#1a237e)' };

const AllMuhurthamsPage = () => {
  const [data, setData] = useState([]);
  const [year, setYear] = useState(2026);
  const [month, setMonth] = useState('all');

  useEffect(() => {
    axios.get('/data/muhurtham-results-2022-2029.json').then(r => setData(r.data)).catch(() => {});
  }, []);

  const filtered = data.filter(d => {
    if (!d.EnglishDate) return false;
    const p = d.EnglishDate.split('/');
    const y = parseInt(p[2]);
    if (y !== year) return false;
    if (month !== 'all' && parseInt(p[0]) !== parseInt(month)) return false;
    return true;
  });

  const MONTHS_EN = ['','January','February','March','April','May','June','July','August','September','October','November','December'];

  return (
    <div style={{background:T.bg,minHeight:'80vh',padding:'10px'}}>
      <div style={{background:T.header,padding:'12px',borderRadius:'10px',textAlign:'center',marginBottom:'10px'}}>
        <img src="/images/rituals/kalyana-uthsavam.jpg" alt="கல்யாணம்" style={{height:'50px',borderRadius:'8px',marginBottom:'6px',border:'2px solid #f0d48a'}} />
        <h1 style={{color:'#fff',margin:0,fontSize:'1rem',fontWeight:900}}>💍 முகூர்த்த தினங்கள் (முழு)</h1>
        <div style={{color:'#c8e6c9',fontSize:'0.7rem'}}>All Muhurtham Days 2022-2029</div>
      </div>
      <div style={{display:'flex',gap:'6px',marginBottom:'10px'}}>
        <select value={year} onChange={e=>setYear(parseInt(e.target.value))} style={{flex:1,padding:'8px',borderRadius:'6px',border:'1px solid #ccc',fontWeight:700}}>
          {[2022,2023,2024,2025,2026,2027,2028,2029].map(y=><option key={y} value={y}>{y}</option>)}
        </select>
        <select value={month} onChange={e=>setMonth(e.target.value)} style={{flex:1,padding:'8px',borderRadius:'6px',border:'1px solid #ccc',fontWeight:700}}>
          <option value="all">All Months</option>
          {[1,2,3,4,5,6,7,8,9,10,11,12].map(m=><option key={m} value={m}>{MONTHS_EN[m]}</option>)}
        </select>
      </div>
      <div style={{fontSize:'0.7rem',color:T.greenDk,fontWeight:700,marginBottom:'6px'}}>📊 {filtered.length} muhurtham days found</div>
      <div style={{overflowX:'auto'}}>
        <table style={{width:'100%',borderCollapse:'collapse',fontSize:'0.6rem'}}>
          <thead><tr style={{background:T.greenDk,color:'#fff'}}>
            <th style={{padding:'4px',border:'1px solid #ccc'}}>#</th>
            <th style={{padding:'4px',border:'1px solid #ccc'}}>Date</th>
            <th style={{padding:'4px',border:'1px solid #ccc'}}>Day</th>
            <th style={{padding:'4px',border:'1px solid #ccc'}}>Nakshatra</th>
            <th style={{padding:'4px',border:'1px solid #ccc'}}>Thithi</th>
            <th style={{padding:'4px',border:'1px solid #ccc'}}>Lagna Time</th>
          </tr></thead>
          <tbody>
            {filtered.map((d,i) => (
              <tr key={i} style={{background:i%2?'#f5f5f5':'#fff'}}>
                <td style={{padding:'3px',border:'1px solid #eee',textAlign:'center'}}>{i+1}</td>
                <td style={{padding:'3px',border:'1px solid #eee',fontWeight:700,color:T.greenDk,whiteSpace:'nowrap'}}>{d.EnglishDate}</td>
                <td style={{padding:'3px',border:'1px solid #eee'}}>{d.Day || d.DayNameInTamil || ''}</td>
                <td style={{padding:'3px',border:'1px solid #eee'}}>{d.Nakshatra || d.NakshatraNameInTamil || ''}</td>
                <td style={{padding:'3px',border:'1px solid #eee'}}>{d.Thithi || d.ThithiNameInTamil || ''}</td>
                <td style={{padding:'3px',border:'1px solid #eee',color:T.orange,fontWeight:600}}>{d.LagnaTime || d.MuhurthamTime || ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{textAlign:'center',marginTop:'10px'}}>
        <img src="/images/rituals/vivaha-list.jpg" alt="விவாஹ பட்டியல்" style={{maxWidth:'100%',borderRadius:'8px',border:'2px solid '+T.border}} />
      </div>
    </div>
  );
};
export default AllMuhurthamsPage;